<template>
	<v-dialog
		:value="true"
		width="50%"
		persistent
		scrollable
		:fullscreen="$vuetify.breakpoint.mobile"
	>
		<v-card>
			<v-card-title class="text-h3 primary--text">CARGAR MUESTRAS</v-card-title>
			<v-card-text>
				<lector-codigos
					:desactivado="mostrarLecturaManual"
					@codigoLeido="leer"
				></lector-codigos>
				<codigo-manual
					v-if="mostrarLecturaManual"
					@cerrar="cerrarCodigoManual"
				></codigo-manual>
				<v-container grid-list-md>
					<v-layout row wrap>
						<v-flex xs12>
							<v-simple-table fixed-header height="500px">
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left primary--text">
												Código
											</th>
											<th class="text-left primary--text">
												Fecha Toma
											</th>
											<th class="text-left primary--text">
												Hora Toma
											</th>
											<th class="text-left primary--text">
												Tipo Análisis
											</th>
											<th></th>
										</tr>
									</thead>
									<tbody v-if="muestras.length === 0">
										<td colspan="3">
											<div class="ma-3">
												Por favor lea las muestras a cargar ...
											</div>
										</td>
									</tbody>
									<tbody>
										<tr v-for="m in muestras" :key="m.Codigo">
											<td>{{ m.Codigo }}</td>
											<td>{{ formatDate(m.FechaMuestra.split("T")[0]) }}</td>
											<td>
												{{ m.FechaMuestra.split("T")[1].substring(0, 5) }}
											</td>
											<td>{{ m.TipoAnalisis }}</td>
											<td>
												<v-btn
													@click.prevent="borrarMuestra(m)"
													icon
													color="error"
												>
													<v-icon>close</v-icon>
												</v-btn>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-btn class="mr-5" text @click.prevent="cerrar(false)">
					Cancelar</v-btn
				>
				<v-spacer> </v-spacer>
				<div class="mr-3">
					<span class="font-weight-bold">TOTAL DE MUESTRAS:</span> {{ total }}
				</div>
				<v-btn class="mr-5" text @click.prevent="lecturaManual"
					><v-icon>add</v-icon> Lectura Manual</v-btn
				>
				<v-btn v-if="!!muestras.length" color="primary" @click.prevent="guardar"
					><v-icon>save</v-icon> Cargar Muestras</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import LectorCodigos from "../../components/LectorCodigos.vue";
import ServicioLaboratorio from "../../services/laboratorio";
import CodigoManual from "../../components/CodigoManual.vue";
export default {
	name: "cargarmuestras",
	components: { LectorCodigos, CodigoManual },
	data() {
		return {
			muestras: [],
			mostrarLecturaManual: false,
		};
	},
	computed: {
		total() {
			return this.muestras.length;
		},
	},
	methods: {
		cerrarCodigoManual(codigo) {
			if (codigo) {
				this.leer(codigo);
			}
			this.mostrarLecturaManual = false;
		},
		lecturaManual() {
			this.mostrarLecturaManual = true;
		},
		async leer(codigo) {
			if (this.muestras.some((m) => m.Codigo === codigo)) {
				return (this.$root.mensajeError =
					"La muestra ya se encuentra en la lista.");
			}
			const res = await ServicioLaboratorio.cargaCodigo(codigo);
			if (res.data.result === 1) {
				this.muestras.push({ Codigo: codigo, ...res.data.data.Table0[0] });
			} else {
				this.$root.mensajeError = res.data.message;
			}
		},
		async guardar() {
			const muestras = this.muestras.map((m) => {
				return {
					MuestraDetalleID: m.MuestraDetalleID,
				};
			});
			const res = await ServicioLaboratorio.cargarMuestras(muestras);
			if (res.data.result === 1) {
				const etiquetas = this.muestras.map((m) => m.Codigo);
				this.imprimirEtiquetas(etiquetas);
				this.$root.mensajeExito = "Las muestras fueron cargadas con éxito";
				this.cerrar(true);
			} else {
				this.$root.mensajeError =
					res.data.message || "Error al cargar las muestras";
			}
		},
		cerrar(cambios = false) {
			this.$emit("cerrar", cambios);
		},
		borrarMuestra(m) {
			const ix = this.muestras.indexOf(m);
			this.muestras.splice(ix, 1);
		},
		imprimirEtiquetas(codigos) {
			const self = this;
			var ws = new WebSocket(`ws://${this.config.ServicioImpresion}/service`);
			ws.onopen = function() {
				var json = JSON.stringify({
					Comando: "IMPRIMIR_ETIQUETAS",
					Datos: { Codigos: codigos },
				});
				ws.send(json);
			};

			ws.onmessage = function(evt) {
				var data = JSON.parse(evt.data);
				if (!data.Exito) {
					self.$root.mensajeError = "No se puedieron imprimir las etiquetas";
				}
			};
			ws.onclose = function() {};
			ws.onerror = function(event) {
				self.$root.mensajeError = "No se puedieron imprimir las etiquetas";
			};
		},
	},
};
</script>
